module.exports = __webpack_public_path__ + "static/overview-diagram-8ae890676341fee350c7d5f61d911063.png";